export { default as WorkspaceSidebar } from "./WorkspaceSidebar";
export type { WorkspaceSidebarProps, ProductDropdownItem } from "./WorkspaceSidebar";

export const SIDEBAR_WIDTH = 260;

export const WORKSPACE_ACCENT_COLORS: Record<string, string> = {
  master: "#7C3AED",
  partner: "#3D79F2",
  eves: "#3762e3",
  device: "#55b685",
};
